import { ExpressionToken, IndexedExpression } from '.';

export const genExistingSearchItems = ({ expressions, index }: IndexedExpression): ExpressionToken<unknown>[] => {
  const expression = expressions[index];
  if (!expression) return [];
  const searchItems: ExpressionToken<unknown>[] = [];
  const positionIndex = expression.operator === 'position' ? index : index - 1;
  for (let i = positionIndex + 1; i < expressions.length; ++i) {
    const expression = expressions[i];
    switch (expression.operator) {
      case 'group_end':
      case 'not_end': {
        i = expressions.length;
        break;
      }
      case 'expression':
        searchItems.push(expression);
        break;
    }
  }

  for (let i = positionIndex - 1; i >= 0; --i) {
    const expression = expressions[i];
    switch (expression.operator) {
      case 'group_start':
      case 'not_start': {
        i = -1;
        break;
      }
      case 'expression':
        searchItems.push(expression);
        break;
    }
  }
  return searchItems;
};
